export enum LogType {
	INFO = 1,
	WARN = 2,
	ERROR = 3
}

export class LogEntry {
	id:number = 0;
	app:string = "";
	logType:LogType = LogType.INFO;
	dossierId:number = 0;
	userId:number = 0;
	message:string = "";
	stack:string = "";
	timeStamp:Date = new Date();

	constructor(data:any) {
		this.id = data.ID;
		this.app = data.App;
		this.logType = data.LogType;
		this.userId = data.UserID;
		this.dossierId = data.DossierID;
		this.message = data.Message;
		this.stack = data.Stack;
		this.timeStamp = new Date(data.TimeStamp * 1000);
	}
}